import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

const curry = (Component) => (curryProps) => (props) => (
  <Component {...curryProps} {...props} />
);

export const TwoWide = ({ ColGroup, Col, children }) => {
  const [first, ...rest] = children;
  return (
    <ColGroup>
      <Col>{first}</Col>
      <Col>{rest}</Col>
    </ColGroup>
  );
};

export const makeTwoWide = curry(TwoWide);

export const colGroup = ({ layout, Col }) => css`
  display: flex;
  margin-left: calc(${layout.gutter || '0px'} / -2);
  margin-right: calc(${layout.gutter || '0px'} / -2);

  ${Col} {
    padding-left: calc(${layout.gutter || '0px'} / 2);
    padding-right: calc(${layout.gutter || '0px'} / 2);
  }
`;

export const section = ({ layout }) => css`
  padding-top: calc(${layout.vgutter || '0px'} / 2);
  padding-bottom: calc(${layout.vgutter || '0px'} / 2);
`;

export const Section = styled('div')`
  ${section}
`;
export const makeSection = curry(Section);

export const ColGroup = styled('div')`
  ${colGroup}
`;
export const makeColGroup = curry(ColGroup);

export const Col = styled('div')``;

export const PaddedWrapper = styled('div')`
  padding: ${(props) => props.layout.padding || '0px'};
`;

export const makePaddedWrapper = curry(PaddedWrapper);
